import Vue from 'vue'
import Router from 'vue-router'
import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/components/containers/DefaultContainer')
const ViewStaffDashboard = () => import('./staff/dashboard')
const ViewStaffSliders = () => import('./staff/elements/crudSliders')
const ViewStaffPopups = () => import('./staff/elements/crudPopups')
const ViewStaffDownloads = () => import('./staff/elements/crudDownloads')
const ViewStaffPaymentMethods = () => import('./staff/elements/crudPaymentMethods')
const ViewStaffPages = () => import('./staff/crudPages')
const ViewStaffPagesBlocks =() => import('./staff/crudPagesBlocksContents')
const ViewStaffSettings =() => import('./staff/crudSettings')
const ViewStaffBlocks =() => import('./staff/crudBlocks')
const ViewStaffStoreDeliveries =() => import('./staff/crudStoreDeliveries')
const ViewStaffStoreDiscounts =() => import('./staff/crudStoreDiscounts')
const ViewStaffPortabilityTemplate =() => import('./staff/crudPortabilityTemplate')
const ViewStaffTemplate =() => import('./staff/crudTemplate')

Vue.use(Router)

// reference (access.view_reference / m_modules_permissions.reference) ->
// nombre de ruta. Fuente única, ver router/viewsRegistry.js.
const VIEWS = {
  dashboard: 'ContentsSttaffDashboard',
  crudSliders: 'ContentsSttaffSliders',
  crudPopups: 'ContentsSttaffPopups',
  crudDownloads: 'ContentsSttaffDownloads',
  crudPaymentMethods: 'ContentsSttaffPaymentMethods',
  crudPages: 'ContentsSttaffPages',
  crudPagesBlocksContents: 'ContentsSttaffConfiguratePagesBlocks',
  crudSettings: 'ContentsSttaffSettings',
  crudBlocks: 'ContentsSttaffBlocks',
  crudStoreDeliveries: 'ContentsSttaffStoreDeliveries',
  crudStoreDiscounts: 'ContentsSttaffStoreDiscounts',
  crudPortabilityTemplate: 'ContentsStaffPortabilityTemplate',
  crudTemplate: 'ContentsStaffTemplate',
}

const router =
  [
    {
      path: '/st/contents',
      component: DefaultContainer,
      children: [
        {
          path: '',
          name: VIEWS.dashboard,
          component: ViewStaffDashboard,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Sitio Web',
          }                                  
        },   
        {
          path: 'sliders',
          name: VIEWS.crudSliders,
          component: ViewStaffSliders,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Sitio Web - Sliders',
          }                                  
        },   
        {
          path: 'popups',
          name: VIEWS.crudPopups,
          component: ViewStaffPopups,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Sitio Web - Popups',
          }                                  
        },   
        {
          path: 'downloads',
          name: VIEWS.crudDownloads,
          component: ViewStaffDownloads,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Sitio Web - Descargas',
          }                                  
        },  
        {
          path: 'payment-methods',
          name: VIEWS.crudPaymentMethods,
          component: ViewStaffPaymentMethods,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Sitio Web - Métodos de Pago',
          }                                  
        },    
        {
          path: 'pages',
          name: VIEWS.crudPages,
          component: ViewStaffPages,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Sitio Web - Páginas',
          }                                  
        },    
        {
          path: 'pages-block/:blockID',
          name: VIEWS.crudPagesBlocksContents,
          component: ViewStaffPagesBlocks,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Sitio Web - Bloques de Páginas',
          }                                  
        },    
        {
          path: 'settings',
          name: VIEWS.crudSettings,
          component: ViewStaffSettings,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Sitio Web - Configuración',
          }                                  
        },
        {
          path: 'blocks',
          name: VIEWS.crudBlocks,
          component: ViewStaffBlocks,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Sitio Web - Bloques',
          }                                  
        },        
        {
          path: 'store-deliveries',
          name: VIEWS.crudStoreDeliveries,
          component: ViewStaffStoreDeliveries,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Sitio Web - Entregas',
          }                                  
        },
        {
          path: 'store-discounts',
          name: VIEWS.crudStoreDiscounts,
          component: ViewStaffStoreDiscounts,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Sitio Web - Descuentos',
          }                                  
        },                
        {
          path: 'portability-template',
          name: VIEWS.crudPortabilityTemplate,
          component: ViewStaffPortabilityTemplate,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Sitio Web - Portabilidad',
          }                                  
        },        
        {
          path: 'template',
          name: VIEWS.crudTemplate,
          component: ViewStaffTemplate,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Sitio Web - Plantilla',
          }                                  
        },                            
      ]
    },

    {
      path: '/cu/contents',
      component: DefaultContainer,
      children: [

      ]
    },

    {
      path: '/su/contents',
      component: DefaultContainer,
      children: [

      ]
    },
  ]

export default router
export { VIEWS }
